import { emptys } from "../../../../data/main";
import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { getCurrentDate } from "../../../../utils/getCurrentDate";

export const createCommissionMsg = async ({
  windowValues,
  customUpdate,
  setMsg,
  setWindowValues,
  logoutAction,
  closeMsg,
}: stdObject) => {
  setMsg("loading");
  console.log("windowValues", windowValues);
  const createCommissionPayload = {
    ...windowValues.data,
    date: emptys.includes(windowValues.date)
      ? getCurrentDate(true)
      : windowValues.date.replace("T", " "),
  };
  console.log("createCommissionPayload", createCommissionPayload);

  const createCommissionResponse: stdObject = await sendData({
    endPoint: "approveCommission",
    payload: createCommissionPayload,
    logoutAction,
  });
  console.log("createCommissionResponse", createCommissionResponse);

  if (createCommissionResponse.success && createCommissionResponse.status) {
    customUpdate.current = { mainInfo: "COMM" };
  }
  closeMsg();
  setWindowValues({});
};
